<div class="searchable-select" [class.searchable-select--open]="isOpen">
	<div class="searchable-select__field">
		<input
			#input
			type="text"
			class="searchable-select__input"
			role="combobox"
			[attr.aria-expanded]="isOpen"
			[attr.aria-controls]="listId"
			[attr.aria-activedescendant]="activeIndex >= 0 ? listId + '-' + activeIndex : null"
			[attr.data-testid]="testId"
			[placeholder]="placeholder"
			[disabled]="disabled"
			[value]="query"
			autocomplete="off"
			autocapitalize="off"
			spellcheck="false"
			(input)="onInput($any($event.target).value)"
			(focus)="open()"
			(keydown)="onKeydown($event)"
		/>
		<button
			type="button"
			class="searchable-select__toggle"
			aria-label="Show all options"
			[disabled]="disabled"
			(click)="toggle()"
		>
			<span class="searchable-select__chevron"></span>
		</button>
	</div>

	<ul
		*ngIf="isOpen"
		[id]="listId"
		class="searchable-select__list"
		role="listbox"
	>
		<li
			*ngFor="let option of filtered; let i = index; trackBy: trackByLabel"
			[id]="listId + '-' + i"
			class="searchable-select__option"
			[class.searchable-select__option--active]="i === activeIndex"
			[class.searchable-select__option--disabled]="option.disabled"
			role="option"
			[attr.aria-selected]="i === activeIndex"
			(pointerenter)="activeIndex = i"
			(click)="choose(option)"
		>
			{{ option.label }}
		</li>
		<li *ngIf="filtered.length === 0" class="searchable-select__empty">
			No matching products
		</li>
	</ul>
</div>
